import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	menuButton: {
		marginRight: theme.spacing(2)
	},
	title: {
		flexGrow: 1
	},
	bar: {
		backgroundColor: '#383838'
	}
}))

export default function ButtonAppBar() {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<AppBar position="static" className={classes.bar}>
				<Toolbar>
					<Typography variant="h6" className={classes.title}>
						Elecciones 2020
					</Typography>
					<div style={{ display: 'flex', minWidth: 100, justifyContent: 'space-around' }}>
						<FacebookShareButton url="http://fundacionmohme.org/especiales/vigilancia-electoral">
							<FacebookIcon />
						</FacebookShareButton>
						<TwitterShareButton url="http://fundacionmohme.org/especiales/vigilancia-electoral">
							<TwitterIcon />
						</TwitterShareButton>
						<WhatsappShareButton url="http://fundacionmohme.org/especiales/vigilancia-electoral">
							<WhatsAppIcon />
						</WhatsappShareButton>
					</div>
				</Toolbar>
			</AppBar>
		</div>
	)
}
